import {Route, BrowserRouter as Router, Routes} from 'react-router-dom'
import GlobalStyle from '../components/GlobalStyle/globalStyles'
import SSOXpertKnowledgeAdmin from '../components/AuthContext/SSOXpertKnowledgeAdmin'
import AppXpertKnowledgeContainer from '../components/AppXpertKnowledgeContainer/AppXpertKnowledgeContainer'
import XpertKnowledge from './XpertKnowledge'
// import XpertKnowledgeDetails from './XpertKnowledge/XpertKnowledgeDetails'
import XpertKnowledgeTutorial from './XpertKnowledgeTutorial'
import XpertKnowledgeTutorialEdit from './XpertKnowledgeTutorial/XpertKnowledgeTutorialEdit'
import SSOXpertKnowledge from '../components/AuthContext/SSOXpertKnowledge'
import Error from './Error'
import Login from './Login'
import Settings from './Settings/Settings'
import {XpertKnowledgeAuthContextProvider} from '../components/AuthContext/XpertKnowledgeAuthContext'
import XpertKnowledgeAssets from './XpertKnowledgeAssets/XpertKnowledgeAssets'
import XpertKnowledgeBuffer from './XpertKnowledgeBuffer'
import XpertKnowledgeTryPrompt from './XpertKnowledgeTryPrompt/XpertKnowledgeTryPrompt'
import XpertKnowledgePublicTutorial from './XpertKnowledgeTutorialPublic'
import XpertKnowledgeTutorialNotFound from './XpertKnowledgeTutorialPublic/components/XpertKnowledgeTutorialNotFound'
import XpertKnowledgeTutorialDebug from './XpertKnowledgeTutorialDebug'

function App() {
  return (
    <Router>
      <GlobalStyle />
      <XpertKnowledgeAuthContextProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/xpert-knowledge/:xpertKnowledgeId/public" element={<XpertKnowledgePublicTutorial />} />
          <Route element={<AppXpertKnowledgeContainer />}>
            <Route path="/rag/sso/:token" element={<SSOXpertKnowledgeAdmin />} />
            <Route
              path="/xpert-knowledge/*"
              element={
                <Routes>
                  <Route path="/" element={<XpertKnowledge />}>
                    {/* <Route path=":xpertKnowledgeId" element={<XpertKnowledgeDetails />} /> */}
                  </Route>
                  <Route path="/settings" element={<Settings />} />
                  <Route path="/:xpertKnowledgeId/tutorial" element={<XpertKnowledgeTutorial />}>
                    <Route path="edit" element={<XpertKnowledgeTutorialEdit />} />
                  </Route>

                  <Route path="/:xpertKnowledgeId/tutorial/debug" element={<XpertKnowledgeTutorialDebug />} />
                  <Route path=":xpertKnowledgeId/assets" element={<XpertKnowledgeAssets />} />
                  <Route path=":xpertKnowledgeId/debug" element={<XpertKnowledgeTryPrompt />} />
                  <Route path="/sso/:token" element={<SSOXpertKnowledge />} />
                  <Route path="/error" element={<Error />} />
                  <Route path="/tutorial/not-found" element={<XpertKnowledgeTutorialNotFound />} />
                  <Route path="/buffer/status" element={<XpertKnowledgeBuffer />} />
                </Routes>
              }
            />
          </Route>
        </Routes>
      </XpertKnowledgeAuthContextProvider>
    </Router>
  )
}

export default App
